import { createSelector } from '@ngrx/store';
import { RootSelectors } from '@virtual-trials-workspace/store';

export const getVisitCode = createSelector(RootSelectors.getRouteState, (state) => state.queryParams.visitCode);
